import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const FingerprintIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"fingerprint"} ref={ref}/>
});

FingerprintIcon.displayName = "FingerprintIcon";
